import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
    value: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createBlock(_component_Tag, {
    class: "hover:text-300 cursor-hover",
    value: __props.value,
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push(`/tags/${encodeURIComponent(__props.value)}?p=1`)), ["stop"]))
  }, null, 8, ["value"]))
}
}

})